import { SBModel } from '@supplement-bacon/react-toolkit/models'
import { Localizable } from './Localizable'

export interface EventsCollection
  extends SBModel, Localizable<EventsCollectionLocalizable> {
  events?: number[]
  order: number
  direction: boolean
  displayMode: EventDisplayMode
  periodStart?: number
  periodEnd?: number
}

interface EventsCollectionLocalizable {
  title: string
}

type EventDisplayMode = 'full' | 'condensed'

export const eventsCollectionIsDynamic = (
  eventsCollection?: EventsCollection
): boolean => eventsCollection?.periodStart != null

export const LayoutDirectionOptions: {
  value: boolean
  label: string
}[] = [
  { value: true, label: 'Vertical' },
  { value: false, label: 'Horizontal' },
]

export const DisplayModeOptions: {
  value: EventDisplayMode
  label: string
}[] = [
  { value: 'full', label: 'Full' },
  { value: 'condensed', label: 'Condensed' },
]
